


<div class="question-panel__header">
  <div class="question-panel__title">{{question?.question_prompt}} </div>
  <div class="question-panel__number">
    <p><span data-total="" [ngClass]="getTotalPercentage() > 100 ? 'is-invalid': null" >{{ getTotalPercentage() }}</span> of {{totalperc}} %</p>
  </div>
</div>

<!-- specify max percent here in 'data-percent', else defaults to 100 -->
@for (data of dataset; track trackByIndex(i, data); let i = $index) {
  <div class="custom-answer__group custom-answer__group--percent form-group mb-0"
    data-linked-add="custom-answer-add-2" data-percent="20">
    <div class="custom-answer has-delete">
      <div class="custom-answer__title">
        <app-question-dropdown [options]="options" [showLabel]="false"
          [selectedValue]="data?.answer" (questionAnswer)="setData($event, i)">
        </app-question-dropdown>
      </div>
      <div class="custom-answer__percent">
        <input type="text" currencyMask [options]="maskOptions" placeholder="0" [(ngModel)]="data.percentage" [value]="data?.percentage"
          (blur)="setPercentage($event, i)" class="form-control">
          <span class="custom-answer__percent-indi">%</span>
        </div>
        <div class="custom-answer__delete">
          <a href="javascript:;" (click)="removeData(data, i)" class="action-remove">
            <svg class="icon">
              <use xlink:href="#trash"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
  }

  <aside class="question-add">
    <a href="javascript:void(0)" (click)="addAnother()" class="button-control" id="custom-answer-add-2">
      <svg class="icon">
        <use xlink:href="#plus-filled"></use>
        </svg><strong>{{addAnotherLabel}}</strong>
      </a>
    </aside>
